<script>
import { useHead } from '@unhead/vue';
import structuredData from './lib/structuredData';

export default {
  name: 'StructuredDataCustom',
  render() {
    // Return null since this is only rendering meta data
    return null;
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const structuredDataCustom = structuredData(props, 'custom');

    if (!structuredDataCustom.error) {
      useHead({
        script: [structuredDataCustom]
      });
    }
  }
};
</script>
